import { render } from "./Periodic.vue?vue&type=template&id=1c8ed5ac&scoped=true"
import script from "./Periodic.vue?vue&type=script&lang=js"
export * from "./Periodic.vue?vue&type=script&lang=js"

import "./Periodic.vue?vue&type=style&index=0&id=1c8ed5ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c8ed5ac"]])

export default __exports__